import { VESSEL_CARD_BALTIC_DEFAULT_INDEX } from "../constants/vessel-card-baltic.constants";
import {
  VesselCardBalticIndex,
  VesselCardComparison,
  VesselCardCpSource,
  VesselCardView,
} from "../models/vessel-card.models";
import { atom } from "jotai";

// Keeps page-owned Power BI bookmark choices stable while users inspect modal details.
// Fixtures remain available for development; navigation always starts with live SQL data.
// The PBI menu's data-source switch does not affect Vessel Card.
export const vesselCardMockEnabledAtom = atom(false);
export const vesselCardViewAtom = atom<VesselCardView>("table");
export const vesselCardZnViewAtom = atom<VesselCardView>("table");
export const vesselCardCpSourceAtom = atom<VesselCardCpSource>("imos");

// Retains the comparison and Baltic index when switching views or opening vessel details.
// CP choices remain independent because they do not affect the Baltic benchmark.
export const vesselCardComparisonAtom = atom<VesselCardComparison>("cp");
export const vesselCardBalticIndexAtom = atom<VesselCardBalticIndex>(VESSEL_CARD_BALTIC_DEFAULT_INDEX);
